/**
 * 번역 키 값들을 모아 둔 파일입니다.
 * KEY: DEFAULT_VALUE 쌍으로 이루어 졌습니다.
 */
const TRANS = {
    LOGIN: "로그인",
    LOGIN_ID_INVALID: "로그인 아이디는 알파벳으로 시작하며 6자이상 20자 이하입니다.",
    LOGIN_PW_INVALID: "로그인 패스워드는 알파벳으로 시작하며 6자이상 20자 이하입니다.",
}

/**
 * 번역 데이터가 있으면 번역 데이터 없으면 값을 출력
 */
const TRANSLATE = (K) => {
    if (!TRANS[K]) throw new Error(K + " is invalid translation key!!!");
    TRANS[K] = this.$translate(K, null) || TRANS[K];
}

const MESSAGES = {
    TRANSLATE: TRANSLATE,
    TRANS: TRANS,
}

export {MESSAGES, TRANS}